import { useGetUserAlbums } from '@vimeo/gctl-api/hooks/useUserAlbums';

interface Props {
  canCreateShowcase?: boolean;
  ownerId?: number;
}

/**
 * Hook to fetch the total number of showcases for a user.
 */
export const useShowcases = ({ canCreateShowcase, ownerId }: Props) => {
  const { data } = useGetUserAlbums(
    () => {
      if (!ownerId || !canCreateShowcase) return null;
      return {
        select: ['uri'],
        where: { userId: ownerId },
        headers: { Accept: 'application/vnd.vimeo.*+json;version=3.4.1' },
        query: { perPage: 1 },
      };
    },
    { revalidateOnFocus: false },
  );

  const total = data?.total;

  return { total };
};
